import { NgModule } from '@angular/core';
import '@angular/localize/init';

import { BasketUploadService } from './services/basket-upload.service';
import { SearchBasketsService } from './services/search-baskets.service';

@NgModule({
  imports: [],
  providers: [BasketUploadService, SearchBasketsService],
})
export class DataBasketsModule {}
